<template>
    <div class="loading">
        <div class="spinner"></div>
        <p>{{ message }}</p>
    </div>
</template>

<script setup>
defineProps({
    message: {
        type: String,
        default: 'Loading...'
    }
});
</script>

<style scoped>
.loading {
    text-align: center;
    padding: 60px 20px;
    color: var(--text-primary);
    opacity: 0.9;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(255, 246, 227, 0.2);
    border-top: 4px solid var(--accent);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 20px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>